import { useEffect, useState } from 'react';
import { DefaultNavbar, MenuStateBar, MobileNavbar, StationNavBar } from './Navbar';
interface localProps {
  noDefaultNavbar?: boolean;
  children?: React.ReactNode;
}

export const Chrome = (props: localProps) => {
  const { children, noDefaultNavbar } = props;
  const [pavilionCompactFrame, setPavilionCompactFrame] = useState(false);

  useEffect(() => {
    const steam = typeof window !== 'undefined' && window.playcast?.steamInstall;
    if (!steam) {
      setPavilionCompactFrame(false);
      return;
    }
    const update = () => setPavilionCompactFrame(window.innerWidth <= 400);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const shellFrame = pavilionCompactFrame
    ? 'rounded-tl-[25px] rounded-tr-[5px] rounded-br-[25px] rounded-bl-[5px] border-[3px] border-[#FBBF24] overflow-hidden'
    : 'rounded-lg border-2 border-primary';

  return (
    <div className={`${shellFrame} flex h-screen min-h-screen flex-col overflow-auto text-white`}>
      {/* Window state bar */}
      <MenuStateBar data-testid='menu-state-bar' />

      {/* Mobile nav bar */}
      <MobileNavbar data-testid='mobile-navbar' />

      {/* Nav state bar */}
      {!noDefaultNavbar && <DefaultNavbar data-testid='default-navbar' />}

      <div className='bg-darkest flex flex-1 overflow-hidden'>
        <StationNavBar data-testid='station-nav-bar' />
        {children}
      </div>
    </div>
  );
};
